import script from "./add_new_user.vue?vue&type=script&setup=true&lang=js"
export * from "./add_new_user.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__